import { Component, ElementRef, OnInit, Renderer2, inject, input, model } from '@angular/core';
import { ITabs, Tabs } from './tabs.model';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    imports: [
        CommonModule,
        NgbTooltipModule,
    ],
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

    private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly renderer = inject(Renderer2);

    readonly $tabs = input<Tabs[] | ITabs[] | string[]>([], { alias: 'tabs' });

    readonly $tab = model<string | number | undefined>(undefined, { alias: 'tab' });

    readonly $position = input<'top' | 'bottom' | undefined>('top', { alias: 'position' });
    readonly $direction = input<'start' | 'end' | undefined>('start', { alias: 'direction' });

    items: Tabs[] = [];

    ngOnInit(): void {
        this.renderer.addClass(this.el.nativeElement, `tabs-${this.$position()}`);
        this.renderer.addClass(this.el.nativeElement, `tabs-${this.$direction()}`);

        this.items = this.$tabs()?.map((t) => {
            let tab!: ITabs;
            if (typeof (t) == 'string') {
                tab = { tab: t, title: t } as ITabs;
            } else {
                tab = t;
            }
            return new Tabs(tab);
        });

        if (!this.$tab())
            this.$tab.set(this.items[0].tab);
    }


    onClick(item: Tabs): void {
        if (item.disabled === true)
            return;

        this.$tab.set(item.tab);

        //this.navigate();
    }

    getClass = (): string => {
        return [
            'nav-tabs-' + this.$position(),
            'justify-content-' + this.$direction(),
            (this.$direction() === 'start' ? 'me-auto' : 'ms-auto')
        ].join(' ');
    }
}
